// extracted by mini-css-extract-plugin
module.exports = {"content":"HelpTemplate_content__tQ56y","categoriesContent":"HelpTemplate_categoriesContent__FOBZQ","help":"HelpTemplate_help__jYixr"};